import { useEffect } from 'react';
import { useGetProviderAvailabilityQuery } from '~/store/services/schedule';

import { WindowAvailabilityResult } from '../hooks/useFollowUpAvailability';

interface FollowUpWindowLoaderProps {
  windowKey: string;
  window: FollowUpWindow;
  hostId: string;
  appointmentType: string;
  patientId?: string;
  supportIds?: string[];
  onAvailability: (key: string, result: WindowAvailabilityResult) => void;
  onError: (error: unknown) => void;
}

const FollowUpWindowLoader = ({
  windowKey,
  window,
  hostId,
  appointmentType,
  patientId,
  supportIds,
  onAvailability,
  onError,
}: FollowUpWindowLoaderProps) => {
  const {
    data: availabilityData,
    isFetching: isAvailabilityFetching,
    isError: isAvailabilityError,
    error: availabilityError,
  } = useGetProviderAvailabilityQuery({
    appointmentType,
    frequency: 'does-not-repeat',
    ignoreAvailabilitySettings: false,
    minimumProviderCount: 1,
    patientId,
    providerIds: [hostId],
    start: window.startISO,
    end: window.endISO,
    strictAvailabilityRule: true,
    supportIds,
  });

  useEffect(() => {
    if (isAvailabilityFetching) return;
    onAvailability(windowKey, {
      anchors: availabilityData?.data?.availableSlots ?? [],
      isFetching: false,
    });
  }, [availabilityData, isAvailabilityFetching, onAvailability, windowKey]);

  useEffect(() => {
    if (isAvailabilityError && availabilityError) onError(availabilityError);
  }, [availabilityError, isAvailabilityError, onError]);

  return null;
};

export default FollowUpWindowLoader;
